export default __webpack_public_path__ + "assets/images/8faf5b4bcd042b1538066894d0237485.jpg";